import {
  setToken,
  setUserInfo,
  clearUserInfo,
  getToken,
  updateUserTel
} from '@/helper/loginStatusManger.js';

const clearLoginStatus = state => {
  clearUserInfo();
  state.loginToken = '';
  state.userInfo = {};
};

export default {
  namespaced: true,
  state: () => {
    return {
      userInfo: {},
      loginToken: getToken() || ''
    };
  },
  getters: {
    userInfo: state => {
      return state.userInfo;
    },
    loginToken: state => {
      return state.loginToken;
    }
  },
  actions: {
    async getUserInfoByToken ({ commit, getters }) {
      // const loginToken = getters.loginToken;
    },
    setcTokenInfo ({ state, rootState }) {
      const { tel } = state.userInfo || {};
      if (tel && rootState.isValidloginState && state.loginToken) {
        window.localStorage.setItem('cInfo', JSON.stringify({ cToken: state.loginToken, tel }));
      }
    }
  },
  mutations: {
    setUserInfo (state, data) {
      if (data) {
        setUserInfo(data.tel, data.name, data.openid, data.headimgurl, data.eid);
        state.userInfo = data;
      }
    },

    setToken (state, token) {
      if (token) {
        setToken(token);
        state.loginToken = token;
      }
    },

    updateUserTel (state, tel) {
      updateUserTel(tel);
      state.userInfo.tel = tel;
    },

    loginOut (state) {
      clearLoginStatus(state);
    },

    authFail: state => clearLoginStatus(state)
  }
};



// WEBPACK FOOTER //
// ./src/core/user/store.js